import React, { useRef, useState } from "react";
import {
  Eye,
  EyeSlash,
  Shop,
  Phone,
  ArrowRight,
  ShieldCheck,
  LightningCharge,
} from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Utils from "../../utils";
import { createlogin } from "../../services/authServices";
import { decryptData } from "../../utils/crypto";
import { authActions, store } from "../../store";
import CONFIG from "../../config";
import { notify } from "../../components/Common/Alerts";

const AdminLogin = () => {
  const deviceToken = localStorage.getItem("app_fcm_token");
  const deviceType = localStorage.getItem("device_type");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    mobile: "",
    password: "",
  });
  let errorsObj = { mobile: "", password: "" };

  const [errors, setErrors] = useState(errorsObj);
  const [isLoading, setIsLoading] = useState(false);

  const handleMobileValidation = () => {
    let errorMsg = "";

    const mobileRegex = /^\d{10}$/;

    if (!formData.mobile) {
      errorMsg = "Mobile is required";
    } else if (!mobileRegex.test(formData.mobile)) {
      errorMsg = "Enter a valid 10-digit mobile number";
    }

    setErrors((prev) => ({
      ...prev,
      mobile: errorMsg,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const cleanedValue = value.replace(/\D/g, "").slice(0, 10);

      setFormData((prev) => ({
        ...prev,
        mobile: cleanedValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const mobileRef = useRef(null);
  const passwordRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    let errorObj = {};
    let error = false;

    if (!formData?.mobile) {
      errorObj.mobile = "Mobile is required";
      error = true;
      mobileRef.current?.focus();
    } else {
      const mobileRegex = /^\d{10}$/;
      if (!mobileRegex.test(formData.mobile)) {
        errorObj.mobile = "Enter a valid 10-digit mobile number";
        error = true;
        mobileRef.current?.focus();
      }
    }

    if (!formData?.password) {
      errorObj.password = "Password is required";
      error = true;

      if (!errorObj.mobile) {
        passwordRef.current?.focus();
      }
    }

    setErrors(errorObj);

    if (error) return;

    let obj = {
      mobile: formData?.mobile || "",
      password: formData?.password?.trim() || "",
      // device_token: deviceToken,
      // device_type: deviceType,
    };

    setIsLoading(true);

    createlogin(obj)
      .then((response) => {
        const decrypted = decryptData(response?.data?.data);
        let userData = decrypted?.user;

        if (userData) {
          Utils.setDetail(decrypted);
          Utils.setIntervalRemove();
          store.dispatch(authActions.login(decrypted));

          if (
            decrypted.is_store_selected === 0 &&
            Number(userData.role_id) === CONFIG.ROLE_OWNER
          ) {
            navigate("/store-add");
          } else {
            navigate("/dashboard");
          }
        }
      })
      .catch((error) => {
        let decryptError = decryptData(error.response.data.data);
        notify.error(decryptError?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-brand-body font-sans overflow-hidden">
      <div className="w-full md:w-1/2 flex items-center justify-center p-8 md:p-16 relative">
        <div className="absolute top-0 left-0 w-64 h-64 bg-brand-orange/5 rounded-full blur-3xl -z-10 animate-blob" />

        <div className="w-full max-w-md animate-fade-up">
          <div
            className="flex items-center gap-2 mb-12 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <div className="bg-brand-orange p-2 rounded-xl text-white shadow-lg">
              <Shop size={24} />
            </div>
            <span className="text-2xl font-extrabold text-brand-dark">
              Dukaan<span className="text-brand-orange">Setu</span>
            </span>
          </div>

          <div className="mb-10">
            <h2 className="text-4xl font-extrabold text-brand-dark tracking-tight">
              Welcome Back!
            </h2>
            <p className="text-gray-500 mt-2">
              Login karke orders aur stores easily manage karo.{" "}
            </p>
          </div>

          <form className="space-y-6">
            <div className="animate-fade-up [animation-delay:200ms] opacity-0 [animation-fill-mode:forwards]">
              <label className="block text-sm font-bold text-brand-dark mb-2">
                Mobile Number
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-brand-orange transition-transform group-focus-within:scale-110">
                  <Phone size={18} />
                </div>
                <input
                  type="text"
                  inputMode="numeric"
                  autoFocus
                  ref={mobileRef}
                  placeholder="Enter 10 digit number"
                  className="w-full pl-12 pr-4 py-4 bg-white border border-gray-100 rounded-2xl outline-none focus:border-brand-orange focus:ring-4 focus:ring-brand-orange/10 transition-all font-medium shadow-sm"
                  value={formData.mobile}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onBlur={handleMobileValidation}
                  name="mobile"
                  min={0}
                />
              </div>
              {errors.mobile && (
                <p className="text-red-500 text-xs mt-1">{errors.mobile}</p>
              )}
            </div>

            <div className="animate-fade-up [animation-delay:400ms] opacity-0 [animation-fill-mode:forwards]">
              <label className="block text-sm font-bold text-brand-dark mb-2">
                Password
              </label>
              <div className="relative group">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  className="w-full px-5 py-4 bg-white border border-gray-100 rounded-2xl outline-none focus:border-brand-orange focus:ring-4 focus:ring-brand-orange/10 transition-all font-medium pr-12 shadow-sm"
                  value={formData.password}
                  onChange={handleChange}
                  name="password"
                  ref={passwordRef}
                />

                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-brand-orange transition-colors"
                >
                  {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                </button>
              </div>
              {errors.password && (
                <p className="text-red-500 text-xs mt-1">{errors.password}</p>
              )}
            </div>

            <div className="pt-2 animate-fade-up [animation-delay:600ms] opacity-0 [animation-fill-mode:forwards]">
              <button
                type="button"
                onClick={handleSubmit}
                className="bg-brand-gradient bg-200% text-white w-full py-4 rounded-2xl font-bold text-lg shadow-xl shadow-brand-orange/20 animate-shimmer hover:brightness-110 active:scale-95 transition-all flex items-center justify-center gap-3"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    {/* Spinner */}
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                    Logging in...
                  </>
                ) : (
                  <>
                    Login to Account <ArrowRight strokeWidth={3} />
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="hidden md:flex w-1/2 bg-brand-gradient relative items-center justify-center p-12 overflow-hidden">
        <div className="absolute top-[-10%] right-[-10%] w-96 h-96 bg-white/10 rounded-full blur-3xl animate-blob" />
        <div className="absolute bottom-[-10%] left-[-10%] w-96 h-96 bg-orange-300/20 rounded-full blur-3xl animate-blob [animation-delay:3s]" />

        <div className="relative z-10 text-center space-y-8 animate-float">
          <div className="bg-white/10 backdrop-blur-md p-8 rounded-full border border-white/20 shadow-2xl inline-block mb-8">
            <Shop size={120} className="text-white drop-shadow-lg" />
          </div>

          <div className="text-white space-y-4">
            <h3 className="text-4xl md:text-5xl font-extrabold flex flex-wrap justify-center gap-x-3">
              Build your Digital Empire
            </h3>
            <p className="text-orange-50 text-lg max-w-sm mx-auto">
              Join 10,000+ shopkeepers who have digitized their business with
              DukaanSetu.
            </p>
          </div>

          <div className="flex justify-center gap-4 mt-12">
            <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-xl text-white text-sm font-bold flex items-center gap-2">
              <ShieldCheck /> 100% Secure
            </div>
            <div className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-xl text-white text-sm font-bold flex items-center gap-2">
              <LightningCharge /> Fast & Free
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
